[
  {
    "url": "https://.*\\.crm\\w+\\.dynamics\\.com\\/main\\.aspx\\?.*etn=.*account",
    "urlForMock": "https://org9b404ab4.crm4.dynamics.com/main.aspx%3Fappid%3D7fb7930a-ad88-ef11-ac21-6045bd913191%26pagetype%3Dentityrecord%26etn%3Daccount%26id%3D8390197e-ad8b-ef11-ac21-000d3aaba1f2/index.html",
    "elements": [
      {
        "name": "Company Name",
        "selector": "#mainContent section[data-id='ACCOUNT_INFORMATION'] input[data-id='name.fieldControl-text-box-text']",
        "attributes": ["value"]
      },
      {
        "name": "Company Website",
        "selector": "#mainContent section[data-id='ACCOUNT_INFORMATION'] input[data-id='websiteurl.fieldControl-url-text-input']",
        "attributes": ["value"],
        "iframeSelector": "#mainContent iframe"
      }
    ]
  },
  {
    "url": "https://.*\\.crm\\w+.dynamics\\.com\\/main\\.aspx\\?.*etn=.*contact",
    "urlForMock": "https://org9b404ab4.crm4.dynamics.com/main.aspx%3Fappid%3D7fb7930a-ad88-ef11-ac21-6045bd913191%26pagetype%3Dentityrecord%26etn%3Dcontact%26id%3Dbcb16ec2-ae8b-ef11-ac21-000d3aaba1f2/index.html",
    "elements": [
      {
        "name": "First Name",
        "selector": "#mainContent section[data-id='CONTACT_INFORMATION'] input[data-id='fullname_compositionLinkControl_firstname.fieldControl-text-box-text']",
        "attributes": ["value"],
        "iframeSelector": "#mainContent iframe"
      },
      {
        "name": "Last Name",
        "selector": "#mainContent section[data-id='CONTACT_INFORMATION'] input[data-id='fullname_compositionLinkControl_lastname.fieldControl-text-box-text']",
        "attributes": ["value"],
        "iframeSelector": "#mainContent iframe"
      },
      {
        "name": "Contact Email",
        "selector": "#mainContent section[data-id='CONTACT_INFORMATION'] input[data-id='emailaddress1.fieldControl-mail-text-input']",
        "attributes": ["value"],
        "iframeSelector": "#mainContent iframe"
      }
    ]
  },
  {
    "url": "https://.*\\.crm\\w+.dynamics\\.com\\/main\\.aspx\\?.*etn=*.lead",
    "elements": [
      {
        "name": "Full Name",
        "selector": "#mainContent #appenginerootcontainerid #worklistrootcontainerid div[data-automationid='ListCell'] > div > div[role='group'] > div[role='group'] > div.ms-Stack > div:first-child span"
      },
      {
        "name": "First Name",
        "selector": "#mainContent section[data-id='Contact'] input[data-id='fullname_compositionLinkControl_firstname.fieldControl-text-box-text']",
        "attributes": ["value"]
      },
      {
        "name": "Last Name",
        "selector": "#mainContent section[data-id='Contact'] input[data-id='fullname_compositionLinkControl_lastname.fieldControl-text-box-text']",
        "attributes": ["value"]
      },
      {
        "name": "Company Name",
        "selector": "#mainContent #appenginerootcontainerid #worklistrootcontainerid div[data-automationid='ListCell'] > div > div[role='group'] > div[role='group'] > div.ms-Stack > div:nth-child(2) .ms-StackItem:last-child span"
      },
      {
        "name": "Company Website",
        "selector": "#mainContent section[data-id='company'] div[data-id='websiteurl-FieldSectionItemContainer'] input[data-id='websiteurl.fieldControl-url-text-input']",
        "attributes": ["value"],
        "iframeSelector": "#mainContent iframe"
      },
      {
        "name": "Contact Email",
        "selector": "#mainContent section[data-id='Contact'] div[data-id='emailaddress1'] input[type='email']",
        "attributes": ["value"],
        "iframeSelector": "#mainContent iframe"
      }
    ]
  }
]
